module.exports = __webpack_public_path__ + "img/wallet_03_f(x)bridge.b6430e12.png";